(function() {
    'use strict';

    angular.module('elogbooks.admin.request-logs', []);
})();   